import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import { setPageMeta } from '../utils/seo';
import './Home.css';
import workingbg from '../Assets/workingbg.png';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay, ease: 'easeOut' },
  }),
};

const Working = () => {
  useEffect(() => {
    setPageMeta('Sapiencia.AI — How Sapiencia Works', 'How Sapiencia secures AI systems end-to-end.');
  }, []);

  return (
    <div className="home-container">
      <Navbar />

      <section
        className="diagram-section"
        style={{
          backgroundImage: `
      linear-gradient(
        rgba(5, 10, 20, 0.82),
        rgba(5, 10, 20, 0.88)
      ),
      url(${workingbg})
    `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <motion.div
          className="diagram-wrapper"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
        >
          <p className="eyebrow">HOW IT WORKS</p>
          <h2 className="diagram-title">How Sapiencia Works</h2>

          <div className="diagram-grid">
            <div className="diagram-box source">
              <h4>Data Ingestion</h4>
              <p>Clinical data, sensors, logs, user inputs</p>
            </div>
            <div className="arrow right">→</div>
            <div className="diagram-box models">
              <h4>AI / ML Models</h4>
              <p>LLMs, predictive analytics, decision engines</p>
            </div>
            <div className="arrow right">→</div>
            <div className="diagram-box platform">
              <h4>Sapiencia Security Layer</h4>
              <ul>
                <li>Threat Detection</li>
                <li>Explainability & Audits</li>
                <li>Policy & Compliance Guardrails</li>
                <li>Continuous Monitoring</li>
              </ul>
            </div>

            <div></div>
            <div></div>
            <div className="arrow down">↓</div>
            <div></div>
            <div></div>

            <div></div>
            <div className="diagram-box outcome">
              <h4>Trusted Outcomes</h4>
              <p>Secure • Explainable • Compliant AI</p>
            </div>
            <div></div>
          </div>

          <p className="diagram-caption">
            Sapiencia secures AI systems end-to-end — from ingestion to decision — with continuous monitoring and policy enforcement.
          </p>
        </motion.div>
      </section>

      <Footer />
    </div>
  );
};

export default Working;
